export default ({ colors }) => ({
  chatbot: {
    backgroundColor: colors.chatbot.default,
    position: 'fixed',
    right: 0,
    bottom: 0,
    zIndex: 110
  }
})



// WEBPACK FOOTER //
// ./containers/root/styles.js